import styled from "styled-components";

export const FieldContainer = styled.div`
    margin-bottom: 24px;
`

export const AddButtonContainer = styled.div<{isMobile?: boolean}>`
    margin-top: 12px;
    display: flex;
    flex-direction: ${props=>props.isMobile? 'column':'row'};
`

//<div style={{ flexDirection: 'row', marginBottom: 16 }}>
export const RowContainer = styled.div`
    flex-direction: row;
    margin-bottom: 16px;
    display: flex;
`